import prime from './prime';
import pricing from './pricing';
import passengers from './passengers';
import products from './products';
import user from './user';
import baggages from './baggages';
import productSelection from './productSelection';
import services from './services';
import hotels from './hotels';

export default Object.assign({}, prime, user, pricing, passengers, products, baggages, services, hotels, productSelection);
